<mat-form-field class="wd-100 customSelect" [floatLabel]="floatLabel ? floatLabel :'auto'"
  [appearance]="appearance ? appearance : 'legacy'">

  <mat-select [formControl]="formControl" (valueChange)="valueChanged($event)" [placeholder]="placeholder">

    <mat-option *ngIf="includeAllOption">Todos</mat-option>
    <mat-option *ngFor="let item of data" [value]="item">
      <span *ngIf="!useTranslate">
        {{item[displayField]}}
      </span>
      <span *ngIf="useTranslate">
        {{'SELECT.'+ item[displayField] | translate}}
      </span>
    </mat-option>

  </mat-select>

</mat-form-field>
